import { duration } from "moment";
import { apiSlice } from "./apiSlice";

export const claimSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllClaim: builder.query({
            query: (params) => ({
                url: `Claim`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Claim"],
        }),

        // Export all data (without pagination) in Excel File
        getExportAllClaim: builder.query({
            query: (params) => ({
                url: `Claim`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        getSingleClaimDetails: builder.query({
            query: ({ claimId, params }) => ({
                url: `Claim/${claimId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        createClaim: builder.mutation({
            query: ({ body }) => ({
                url: `Claim`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Claim"],
        }),

        updateClaim: builder.mutation({
            query: ({ body }) => ({
                url: `Claim`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Claim"],
        }),


        getAllClaimCount: builder.query({
            query: (params) => ({
                url: `Claim/summary/${params.projectId}`,
                params,
            }),
            invalidatesTags: ["Claim"],
        }),



    }),
});

export const {
    useGetAllClaimCountQuery,
    useCreateClaimMutation,
    useLazyGetAllClaimCountQuery,
    useUpdateClaimMutation,
    useGetSingleClaimDetailsQuery, 
    useLazyGetAllClaimQuery,
    useLazyGetExportAllClaimQuery,
} = claimSlice;